import React, { act, useEffect, useState } from 'react';
import 'bootstrap-select';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TransactionService from 'service/TransactionService';
import LoadingSpinner from 'component/LoadingSpinner';
import BooleanSlider from 'component/BooleanSlider';

const TransactionForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const navigate = useNavigate();

  const transactionService = TransactionService();

  const [transactionName, setTransactionName] = useState('');
  const [userFullName, setUserFullName] = useState('');
  const [taskName, setTaskName] = useState('');
  const [resultStatus, setResultStatus] = useState('');
  const [type, setType] = useState('');
  const [amount, setAmount] = useState(0);
  const [remarks, setRemarks] = useState('');
  const [createdAt, setCreatedAt] = useState('');

  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setIsLoadingDetail(true)
    try {
      const res = await transactionService.transactionDetail(token, id ?? "0");
      console.log(res)
      setTransactionName(res.data?.transactionName!)
      setUserFullName(res.data?.userFullName!)
      setTaskName(res.data?.taskName!)
      setResultStatus(res.data?.resultStatus!)
      setType(res.data?.type!)
      setAmount(res.data?.amount!)
      setRemarks(res.data?.remarks!)
      setCreatedAt(res.data?.createdAt!)

      setIsLoadingDetail(false)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil detail transaksi';
      window.alert(`Error: ${errorMessage}`);
      setIsLoadingDetail(false)
    }
  };

  useEffect(() => {
    if (id != "0") {
      fetchDetail()
    }
  }, [])

  return (
    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">Transaction Detail</h4>
        <div className="p-4" style={{ background: 'white' }}>

          {
            isLoadingDetail ?
              <LoadingSpinner />
              :
                <div className="row">
                  <div className="col-sm-6">
                    <div>
                      <div className="mb-3">
                        <label htmlFor="transactionName" className="form-label fw-semibold">Transaction Name</label>
                        <input
                          type="text"
                          id="transactionName"
                          className="form-control form-control-compact"
                          value={transactionName}
                          placeholder="Transaction Name"
                          disabled
                          onChange={(e) => setTransactionName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="userFullName" className="form-label fw-semibold">User Full Name</label>
                        <input
                          type="text"
                          id="userFullName"
                          className="form-control form-control-compact"
                          value={userFullName}
                          placeholder="User Full Name"
                          disabled
                          onChange={(e) => setUserFullName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="taskName" className="form-label fw-semibold">Task Name</label>
                        <input
                          type="text"
                          id="taskName"
                          className="form-control form-control-compact"
                          value={taskName}
                          placeholder="Task Name"
                          disabled
                          onChange={(e) => setTaskName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="resultStatus" className="form-label fw-semibold">Result Status</label>
                        <input
                          type="text"
                          id="resultStatus"
                          className="form-control form-control-compact"
                          value={resultStatus}
                          placeholder="Result Status"
                          disabled
                          onChange={(e) => setResultStatus(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div>
                      <div className="mb-3">
                        <label htmlFor="type" className="form-label fw-semibold">Type</label>
                        <input
                          type="text"
                          id="type"
                          className="form-control form-control-compact"
                          value={type}
                          placeholder="Type"
                          disabled
                          onChange={(e) => setType(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="amount" className="form-label fw-semibold">Amount</label>
                        <input
                          type="text"
                          id="amount"
                          className="form-control form-control-compact"
                          value={amount}
                          placeholder="Amount"
                          disabled
                          onChange={(e) => setAmount(Number(e.target.value))}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="createdAt" className="form-label fw-semibold">CreatedAt</label>
                        <input
                          type="text"
                          id="createdAt"
                          className="form-control form-control-compact"
                          value={createdAt}
                          placeholder="Created At"
                          disabled
                          onChange={(e) => setCreatedAt(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="remarks" className="form-label fw-semibold">Remarks</label>
                        <textarea
                          id="remarks"
                          className="form-control form-control-compact"
                          rows={3}
                          value={remarks}
                          placeholder="Remarks"
                          disabled
                          onChange={(e) => setRemarks(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
          }
        </div>
      </div>
    </div>
  );

};

export default TransactionForm;